import { takeLatest, call, put, select } from "redux-saga/effects"
import {SET_LOADS} from '../actionTypes'
import { FETCH_CUSTOMER_SOURCING_LANES, SET_CUSTOMER_SOURCING_LANES, SET_SELECTED_CUSTOMER_SOURCING_LANE, SET_LANE_LOAD_STATS, SET_LANE_OFFERS } from './actionTypes'
import { fetchCustomerLanes, fetchLaneLoadStats, fetchCustomerLaneLoads, fetchLaneOffers } from "./actions"

import { getSelectedCustomerSourcingLane } from "./selectors"



function* workerCustomerSourcingLanesFetch(payload) {
    try {
   
        yield put({type: SET_CUSTOMER_SOURCING_LANES, lanes: []})
        const filter = payload.filter
        const resp = yield call(fetchCustomerLanes, filter)
        if (resp?.data?.length) {
            yield put({ type: SET_CUSTOMER_SOURCING_LANES, lanes: resp.data})
        }

    } catch (error) {
        console.error(error)
    }
}

//TODO: Add try catch
function* workerSelectedCustomerSourcingLane(payload) {

    if (payload.id) {
        try {
            yield put({type: SET_LANE_LOAD_STATS, stats: {}})
            yield put({type: SET_LOADS, loads: []})
            yield put({type: SET_LANE_OFFERS, offers:[]})
            const selectedLane = yield select(getSelectedCustomerSourcingLane)

            // get lane stats
            const resp = yield call(fetchLaneLoadStats, {customer_lane_id: selectedLane.id})
            if (resp?.data) {
                yield put({type: SET_LANE_LOAD_STATS, stats: resp.data})
            }

            const loadsResp = yield call(fetchCustomerLaneLoads, {customer_lane_id: selectedLane.id})
            if (loadsResp?.data?.length) {
                yield put({type: SET_LOADS, loads: loadsResp.data})
            } 

            const offersResp = yield call(fetchLaneOffers, {sourcing_lane_id: selectedLane.lane.id})
            if (offersResp?.data?.length) {
                
                yield put({type: SET_LANE_OFFERS, offers: offersResp.data})
            }


            // let's fetch loads

            // here, we want to start fetching all of the information needed to service the lane
            // getCustomerLaneLoads


            // get the facilities and information

            // appointment time graph maybe

            //Some notes on the lanes,

            // get carrier offers on the lane
        } catch (error) {
            console.error(error)
        }

    }
}

export function* watchCustomerSourcingLanesFetchSaga() {
    yield takeLatest(FETCH_CUSTOMER_SOURCING_LANES, workerCustomerSourcingLanesFetch)
}

export function* watchSelectedCustomerSourcingLanesSaga() {
    yield takeLatest(SET_SELECTED_CUSTOMER_SOURCING_LANE, workerSelectedCustomerSourcingLane)
}